import React, { Fragment, useEffect, useState } from 'react';
import { Box, Divider, Stack, CircularProgress, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { InboxContactChat, InboxContactChatMessage } from 'src/constants/types';

import Message from '../Message';


type ConversationProps = {
  messages: InboxContactChat | null;
  markMessageAsUnread: (message: InboxContactChatMessage) => void;
  isContentReady: boolean;
  showErrorDetails: boolean;
  hideDemoFails: boolean;
  hasMoreMessages?: boolean;
  isLoadingMoreMessages?: boolean;  
};

const Conversation = ({
  messages,
  markMessageAsUnread,
  isContentReady,
  showErrorDetails,
  hideDemoFails,
  hasMoreMessages = false,  
  isLoadingMoreMessages = false,
}: ConversationProps) => {
  const isMobile = useMediaQuery<Theme>(t => t.breakpoints.down('md'));
  const [unreadMessageId, setUnreadMessageId] = useState<string>();
  const [hoverMessageId, setHoverMessageId] = useState<string>(); 
  
  useEffect(() => {
    const unreadMessage = messages?.items.filter(m => !m.isRead)[0];
    if (unreadMessage) {
      setUnreadMessageId(unreadMessage.id);
    } else {
      setUnreadMessageId('');
    }
  }, [messages]);


  return (
    <>
      {!isContentReady && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="70vh"
          width="100%"
          p={2}
          pr={0}
        >
          <CircularProgress size={10} />
        </Box>
      )}

      <Box p={isMobile ? 0 : 5} pr={0} sx={{ opacity: isContentReady ? 1 : 0 }}>
        <Stack spacing={3}>
          {hasMoreMessages && (
            <Box display="flex" justifyContent="center" position="sticky" top={0} bgcolor="background.default" zIndex={10}>
              {isLoadingMoreMessages && (
                <CircularProgress size={12} thickness={4} />
              )}
            </Box>
          )}
          {messages?.items.map(el => (
            <Fragment key={el.id}>
              {el.id === unreadMessageId && <Divider textAlign="center">Unread</Divider>}
              <Message
                message={el}
                showErrorDetails={showErrorDetails}
                hideDemoFails={hideDemoFails}
                markMessageAsUnread={markMessageAsUnread}
                hoverMessageId={hoverMessageId}
                setHoverMessageId={setHoverMessageId}
              />
            </Fragment>
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default Conversation;
